import { apiFetch } from "../utils/apiFetch";
import { clearClientStorageOnLogout } from "../utils/clientStorage";
import { API_BASE_CLIENT as API_BASE, STORAGE_KEYS } from "../config/vars";


export async function getMe() {
    try {
        const res = await apiFetch(`${API_BASE}/login/me`);
        if (!res.ok) return null;
        return res.json();
    } catch (_) {
        return null;
    }
}

export async function logout() {
    try {
        const headers = {};
        try {
            const refresh = localStorage.getItem(STORAGE_KEYS.MOBILE_REFRESH_TOKEN);
            if (refresh) headers["X-Refresh-Token"] = refresh;
        } catch (_) {
            // ignore
        }
        await apiFetch(`${API_BASE}/login/logout`, {
            method: "POST",
            headers,
        });
    } catch (_) {
        // ignore network errors during logout
    }

    clearClientStorageOnLogout();
}
